import { useState } from 'react';
import { CiSquareRemove } from 'react-icons/ci';
import { AiOutlineClose } from 'react-icons/ai';
import popupImage from '../../Assets/Images/newpop.png';
import popupMobileImage from '../../Assets/Images/popmobile.png';

const CloseButton = ({ onContinue }) => (
  <button
    type="button"
    onClick={onContinue}
    aria-label="Skip popup"
    className="absolute top-3 right-3 z-20 flex h-7 w-7 items-center justify-center rounded-md bg-white hover:opacity-80 md:bg-transparent md:h-auto md:w-auto md:p-0"
  >
    <span className="hidden md:block">
      <CiSquareRemove size={28} className="text-black" />
    </span>
    <AiOutlineClose className="block text-black md:hidden" size={16} />
  </button>
);

const PopupImage = () => (
  <div className="relative order-1 w-full md:w-[420px] md:flex-shrink-0 h-[160px] md:h-auto md:min-h-[220px] overflow-hidden bg-transparent">
    <img
      src={popupImage}
      alt="Popup visual"
      className="hidden md:block w-full h-full object-cover"
    />
    <img
      src={popupMobileImage}
      alt="Popup visual"
      className="block md:hidden w-full h-full object-cover object-top"
    />
  </div>
);

const PopupCopy = ({
  isSuccess = false,
  email,
  setEmail,
  handleSubscribe,
  isSubmitting,
  feedback,
  onContinue,
}) => (
  <div
    className={`order-2 flex-1 p-3 sm:p-5 flex flex-col justify-center ${
      isSuccess
        ? 'items-center text-center'
        : 'items-center text-left md:items-start md:text-left'
    }`}
  >
    {isSuccess ? (
      <>
        <h2 className="text-[40px] md:text-[56px] font-bold italic text-black">
          You&apos;re in!
        </h2>
        <p className="mt-4 text-[18px] md:text-[24px] leading-[28px] md:leading-[34px] font-light text-black">
          Thank you for subscribing. Your first
          <br />
          newsletter will be on its way soon.
        </p>
        <button
          type="button"
          onClick={onContinue}
          className="mt-8 w-full max-w-[460px] h-[54px] rounded-md bg-[#037ef3] text-white font-bold text-lg hover:opacity-90"
        >
          Return to homepage
        </button>
      </>
    ) : (
      <>
        <div className="w-full max-w-[300px] md:max-w-[560px] flex flex-col items-start mx-auto md:mx-0">
          <h2 className="hidden md:block text-[41px] leading-tight italic font-light text-black">
            <span className="block whitespace-nowrap">
              <span style={{ fontFamily: 'Lato Thin' }}>Get</span>{' '}
              <span className="font-bold">the inside gist</span>{' '}
              <span style={{ fontFamily: 'Lato Thin' }}>on</span>{' '}
              <span className="font-bold">what&apos;s</span>
            </span>
            <span className="block whitespace-nowrap">
              <span className="font-bold">happening</span>{' '}
              <span style={{ fontFamily: 'Lato Thin' }}>
                at AIESEC in Nigeria!
              </span>
            </span>
          </h2>
          <h2 className="md:hidden text-[24px] leading-[30px] italic font-light text-black text-left">
            <span className="block whitespace-nowrap">
              <span style={{ fontFamily: 'Lato Thin' }}>Get</span>{' '}
              <span className="font-bold">the inside gist</span>{' '}
              <span style={{ fontFamily: 'Lato Thin' }}>on</span>{' '}
              <span className="font-bold">what&apos;s</span>
            </span>
            <span className="block whitespace-nowrap">
              <span className="font-bold">happening</span>{' '}
              <span style={{ fontFamily: 'Lato Thin' }}>at AIESEC in</span>
            </span>
            <span className="block whitespace-nowrap">
              <span style={{ fontFamily: 'Lato Thin' }}>Nigeria!</span>
            </span>
          </h2>
          <p className="mt-4 md:mt-5 text-black text-[14px] leading-[19px] font-light md:text-[21px] md:leading-[29px] text-left">
            <span className="hidden md:inline">
              <span className="whitespace-nowrap">
                Join thousands of young leaders receiving our latest programs,
              </span>
              <br />
              events and stories by subscribing to our newsletter.
            </span>
            <span className="md:hidden">
              Join thousands of young leaders receiving our
              <br />
              latest programs, events and stories by
              <br />
              subscribing to our newsletter.
            </span>
          </p>
          <input
            type="email"
            placeholder="ENTER YOUR EMAIL"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            className="mt-5 mb-4 md:mb-0 md:mt-6 w-full max-w-[300px] md:max-w-[560px] h-[44px] md:h-[54px] border border-[#037ef3] rounded-md px-4 text-black placeholder-black text-[14px] md:text-[22px] outline-none mx-auto md:mx-0"
          />
          <button
            type="button"
            onClick={handleSubscribe}
            disabled={isSubmitting}
            className="mt-0 mb-4 md:mb-0 md:mt-5 w-full max-w-[300px] md:max-w-[560px] h-[44px] md:h-[54px] rounded-md bg-[#037ef3] text-white font-bold text-[14px] md:text-[22px] hover:opacity-90 mx-auto md:mx-0"
          >
            {isSubmitting ? 'Submitting...' : 'Subscribe'}
          </button>
          {feedback && (
            <p className="mt-2 text-[12px] md:text-[14px] text-black">
              {feedback}
            </p>
          )}
        </div>
      </>
    )}
  </div>
);

const PreLandingPopup = ({ onContinue }) => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [feedback, setFeedback] = useState('');
  const [hasSubscribed, setHasSubscribed] = useState(false);

  const handleSubscribe = async () => {
    const trimmedEmail = email.trim();
    const webhookUrl = process.env.REACT_APP_POPUP_WAITLIST_WEBHOOK_URL;
    const googleFormUrl = process.env.REACT_APP_POPUP_GOOGLE_FORM_URL;
    const googleFormEmailEntry =
      process.env.REACT_APP_POPUP_GOOGLE_FORM_EMAIL_ENTRY;

    if (!trimmedEmail || !trimmedEmail.includes('@')) {
      setFeedback('Please enter a valid email address.');
      return;
    }

    if (!webhookUrl && (!googleFormUrl || !googleFormEmailEntry)) {
      setFeedback('Waitlist webhook is not configured yet.');
      return;
    }

    try {
      setIsSubmitting(true);
      setFeedback('');

      if (googleFormUrl && googleFormEmailEntry) {
        const formData = new FormData();
        formData.append(googleFormEmailEntry, trimmedEmail);

        await fetch(googleFormUrl, {
          method: 'POST',
          mode: 'no-cors',
          body: formData,
        });
      } else {
        const response = await fetch(webhookUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: trimmedEmail,
            source: 'pre_landing_popup',
            createdAt: new Date().toISOString(),
          }),
        });

        if (!response.ok) {
          throw new Error('Failed to submit');
        }
      }

      setHasSubscribed(true);
      setEmail('');
    } catch (error) {
      setFeedback('Unable to subscribe right now. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center px-4 py-4 overflow-y-auto">
      <div className="relative font-sec bg-white w-full max-w-[1040px] p-0 rounded-2xl shadow-lg overflow-hidden">
        <CloseButton onContinue={onContinue} />

        <div className="flex flex-col md:flex-row md:items-stretch">
          <PopupImage />
          <PopupCopy
            isSuccess={hasSubscribed}
            email={email}
            setEmail={setEmail}
            handleSubscribe={handleSubscribe}
            isSubmitting={isSubmitting}
            feedback={feedback}
            onContinue={onContinue}
          />
        </div>
      </div>
    </div>
  );
};

export default PreLandingPopup;
